import React, { useEffect, useState, useRef } from "react";
import CancelAppointmentButton from "../Buttons/CancelAppointmentButton/CancelAppointmentButton";
import RescheduleAppointmentButton from "../Buttons/RescheduleAppointmentButton/RescheduleAppointmentButton";
import { useTranslation, Trans } from "react-i18next";
import { useSelector } from "react-redux";

import "./ViewAppointment.css";
import {
  findAppointment,
  findEnrollmentCenterInformation,
} from "./ViewAppointmentUtil";
import { codeDescription, convertCode } from "../../util/Function/CodeUtil";
import {
  findParam,
  getDirections,
} from "../../util/Function/CodeParametersUtil";
import { trimTime } from "../../Coverters/dateConverters";
import { Loader } from "../Loading/Loader";
import { buildName } from "../ClientInformation/ClientInformation";
import { useLocation } from "react-router-dom";
import ReturnTTPButton from "../Buttons/ReturnTTPButton/ReturnTTPButton";
import { GcdsIcon } from "@cdssnc/gcds-components-react";

const ViewAppointment = ({ client, client500, clientNotFound }) => {
  const { programType, applicationType, portWorklocations } = useSelector(
    (state) => {
      return state.portWorklocations;
    },
  );
  const { t } = useTranslation();
  const [enrollmentCenter, setEnrollmentCenter] = useState(null);
  const [appointment, setAppointment] = useState(null);
  const [appointmentNotFound, setAppointmentNotFound] = useState(null);

  const pdfRef = useRef(null);
  useEffect(() => {
    if (client?.clientId) {
      findAppointment(client.clientId, setAppointment, setAppointmentNotFound);
    }
  }, [client]);

  const { state } = useLocation();

  let title = codeDescription(enrollmentCenter);

  let locationAddress = findParam(enrollmentCenter, "locationAddress");
  let locationDirections = getDirections(
    enrollmentCenter,
    t("viewAppointment.directionsLang"),
  );
  findParam(enrollmentCenter, "locationAddress");

  useEffect(() => {
    if (appointment) {
      setEnrollmentCenter(
        findEnrollmentCenterInformation(appointment, portWorklocations),
      );
    }
  }, [appointment, locationDirections, portWorklocations]);

  return (
    <div className="mainContainer">
      <div className="viewAppointmentTitleContainer">
        <h1>
          {" "}
          {state?.apponitmentCreated
            ? t("appointmentConfirmed.title")
            : t("viewAppointment.globalEnrollement")}
        </h1>
      </div>
      <div>
        {state?.apponitmentCreated ? (
          <div className="confirm-container">
            <div style={{ marginTop: "10px", marginRight: "10px" }}>
              <GcdsIcon
                name="checkmark-circle"
                size="h3"
                marginRight="4px"
              ></GcdsIcon>
            </div>
            <p className="confirm-padding">{t("viewAppointment.confirmed")}</p>
          </div>
        ) : null}

        <p className="reschedule-note">{t("viewAppointment.note")}</p>
        <div className="confirm-container">
          <div style={{ marginTop: "10px", marginRight: "10px" }}>
            <GcdsIcon
              name="info-circle"
              size="h3"
              marginRight="4px"
              marginTop="15px"
            ></GcdsIcon>
          </div>
          <p className="please-note-padding">
            <Trans i18nKey="viewAppointment.text" />
          </p>
        </div>
      </div>

      <div className="viewAppointmentContentContainer">
        <div className="pageContainer">
          {clientNotFound ? (
            <span>The client was not found</span>
          ) : (
            <>
              <div
                className="hide-alert-msgs"
                role={
                  !enrollmentCenter && !appointment && !title ? "alert" : "none"
                }
                aria-live="assertive"
              >
                {!enrollmentCenter && !appointment && !title
                  ? t("loading.home")
                  : t("loading.homeFinish")}
              </div>

              <Loader
                loadingLabel={t("global.loading")}
                loading={!enrollmentCenter && !appointment && !title}
                content={
                  <>
                    <div className={"flex"} id={"printContent"}>
                      <div className="appointmentLocationContainer">
                        <h2
                          className="viewApplicantTitle"
                          tabIndex={"0"}
                          aria-label={t("apntInfo.homeTitle")}
                        >
                          {t("apntInfo.homeTitle")}
                        </h2>
                        <p>
                          <b
                            tabIndex={"0"}
                            aria-label={t("apntInfo.interviewDate")}
                          >
                            {t("apntInfo.interviewDate")}{" "}
                          </b>{" "}
                          <span tabIndex={"0"}>{appointment?.date}</span>
                        </p>
                        <p>
                          <b
                            tabIndex={"0"}
                            aria-label={t("apntInfo.interviewTime")}
                          >
                            {t("apntInfo.interviewTime")}{" "}
                          </b>{" "}
                          <span tabIndex={"0"}>
                            {trimTime(appointment?.time)}
                          </span>
                        </p>
                        <p>
                          <b
                            tabIndex={"0"}
                            aria-label={t("apntInfo.interviewLocation")}
                          >
                            {t("apntInfo.interviewLocation")}{" "}
                          </b>{" "}
                          <span tabIndex={"0"}>
                            {codeDescription(enrollmentCenter)}
                          </span>
                        </p>
                        <p>
                          <b tabIndex={"0"} aria-label={t("apntInfo.address")}>
                            {t("apntInfo.address")}{" "}
                          </b>{" "}
                          <span tabIndex={"0"}>{locationAddress}</span>
                        </p>
                        <p>
                          <b
                            tabIndex={"0"}
                            aria-label={t("apntInfo.enrolmentCenterDirection")}
                          >
                            {t("apntInfo.enrolmentCenterDirection")}{" "}
                          </b>{" "}
                          <span tabIndex={"0"}>{locationDirections}</span>
                        </p>
                      </div>
                      <div className="appointmentApplicantContainer">
                        <h2
                          tabIndex={"0"}
                          aria-label={t("apntInfo.homeApplicantTitle")}
                          className="viewApplicantTitle"
                        >
                          {t("apntInfo.homeApplicantTitle")}
                        </h2>
                        <div className="textContainer">
                          <p>
                            <b
                              tabIndex={"0"}
                              aria-label={t("homePage.applicantName")}
                            >
                              {t("homePage.applicantName")}
                            </b>
                            <span tabIndex={"0"}>{buildName(client)}</span>
                          </p>
                          <p>
                            <b
                              tabIndex={"0"}
                              aria-label={t("homePage.usPassId")}
                            >
                              {t("homePage.usPassId")}
                            </b>
                            <span tabIndex={"0"}>{client?.passId}</span>
                          </p>

                          <p>
                            <b
                              tabIndex={"0"}
                              aria-label={t("homePage.program")}
                            >
                              {t("homePage.program")}
                            </b>
                            <span tabIndex={"0"}>
                              {convertCode(
                                client?.applicationProgram,
                                applicationType,
                              )}
                            </span>
                          </p>

                          <p>
                            <b
                              tabIndex={"0"}
                              aria-label={t("homePage.applicationType")}
                            >
                              {t("homePage.applicationType")}
                            </b>
                            <span tabIndex={"0"}>
                              {convertCode(
                                client?.applicationType,
                                programType,
                              )}
                            </span>
                          </p>

                          <br />
                        </div>
                      </div>
                    </div>
                    <div>
                      <br />
                      <div className="text-left">
                        <>
                          <button
                            className="buttonStyling"
                            type={"submit"}
                            onClick={() => window.print()}
                          >
                            {t("appointmentConfirmed.print")}
                          </button>
                        </>
                        <RescheduleAppointmentButton />
                        <CancelAppointmentButton />
                      </div>

                      <div>
                        <ReturnTTPButton />
                      </div>
                    </div>
                  </>
                }
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewAppointment;
